var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 32,
    viewBox: "0 0 97 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.68 0.00999832C55.85 0.00999832 49.74 3.55 49.74 10.1C49.74 17.6 60.57 18.12 60.57 21.89C60.57 23.48 58.75 24.9 55.64 24.9C51.23 24.9 47.93 22.91 47.93 22.91L46.52 29.51C46.52 29.51 50.32 31.19 55.36 31.19C62.83 31.19 68.71 27.47 68.71 20.82C68.71 12.89 57.83 12.39 57.83 8.89C57.83 7.65 59.32 6.28 62.42 6.28C65.92 6.28 68.77 7.72 68.77 7.72L70.15 1.34C70.15 1.34 67.05 0 62.67 0L62.68 0.00999832ZM0.17 0.489998L0 1.45C0 1.45 2.87 1.98 5.46 3.03C8.79 4.23 9.03 4.93 9.59 7.11L15.71 30.7H23.91L36.55 0.5H28.37L20.25 21.04L16.94 3.63C16.64 1.64 15.1 0.5 13.21 0.5H0.17V0.489998ZM39.84 0.489998L33.42 30.69H41.22L47.62 0.489998H39.84ZM83.36 0.489998C81.48 0.489998 80.48 1.5 79.75 3.26L68.32 30.7H76.5L78.08 26.13H88.05L89.01 30.7H96.23L89.93 0.5H83.35L83.36 0.489998ZM84.43 8.65L86.86 19.98H80.36L84.43 8.65Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/visaCard.463083b66a51c669f2ef9fef6165a651.svg";
export { ForwardRef as ReactComponent };